import { Injectable } from '@angular/core';
import {
  ChartNotePatientHandoutMode,
  ChartNotePatientHandoutResponse,
  ShareChartNotePatientHandoutResponse,
} from '@models';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';

@Injectable({ providedIn: 'root' })
export class ChartNotePatientHandoutService extends HttpService<ChartNotePatientHandoutResponse> {
  protected override collectionPath =
    '/provider/patients/{patientId}/chart-notes/{chartNoteId}/patient-handout';

  generate(
    patientId: string,
    chartNoteId: string,
    mode: ChartNotePatientHandoutMode
  ): Observable<ChartNotePatientHandoutResponse> {
    const url = this.buildDynamicUrl({ patientId, chartNoteId });
    return this.http.post<ChartNotePatientHandoutResponse>(url, { mode });
  }

  getHtml(
    patientId: string,
    chartNoteId: string,
    mode: ChartNotePatientHandoutMode
  ): Observable<ChartNotePatientHandoutResponse> {
    const url = this.buildDynamicUrl({ patientId, chartNoteId });
    return this.http.get<ChartNotePatientHandoutResponse>(url, {
      params: this.getHttpParameters({ mode }),
    });
  }

  share(
    patientId: string,
    chartNoteId: string,
    mode: ChartNotePatientHandoutMode
  ): Observable<ShareChartNotePatientHandoutResponse> {
    const url = this.buildDynamicUrl({ patientId, chartNoteId });
    return this.http.post<ShareChartNotePatientHandoutResponse>(
      `${url}/share`,
      {
        mode,
      }
    );
  }
}
